/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Country } from '../../models/country';

export interface GetCountries$Params {
}

export function getCountries(http: HttpClient, rootUrl: string, params?: GetCountries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Country>>> {
  const rb = new RequestBuilder(rootUrl, getCountries.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Country>>;
    })
  );
}

getCountries.PATH = '/geography/countries';
